import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z.object({ labels: z.string(), values: z.string() }).strict(),
    ...commonOptionals,
})
    .strict();
export const pieChartDefinition = {
    type: 'PieChart',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['labels', 'values'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Pie chart over a dataset. Props: sourceDataset (required), mapping ({ labels: string, values: string }). Rows that share the same `labels` value are aggregated by summing `values` — e.g., a 9-row dataset with 3 unique regions produces a 3-slice pie. Slice order preserves first-seen order from the dataset.',
};
//# sourceMappingURL=PieChart.js.map